var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./TrainingTypes.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-a2d210b8!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TrainingTypes.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Users/Payment/TrainingTypes.vue
// module id = 673
// module chunks = 0